import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../security.service';
import { OnboardingService } from 'src/app/anonymous/api/account/services/onboarding.service';

@Component({
  selector: 'app-login-callback',
  templateUrl: './login-callback.component.html'
})
export class LoginCallbackComponent implements OnInit {

  constructor(private router: Router,
    private securityService: SecurityService,
    private onboardingService: OnboardingService) { }

    ngOnInit(): void {
      // let self = this;
      //
      // setTimeout(()=> {
      //   var $userData = this.securityService.getUserData();
      //   $userData.subscribe(ud => {
      //     self.securityService.setUser(ud);
      //
      //     this.onboardingService.checkOnboarding().subscribe((onboarding) => {
      //       if (onboarding.mustOnboard) {
      //         this.router.navigateByUrl('/onboarding');
      //       } else {
      //         this.router.navigateByUrl('/secure');
      //       }
      //     });
      //   });
      // }, 1500);
    }
  }
